// extracted by mini-css-extract-plugin
module.exports = {"LogoList":"styles_LogoList__3Hqfc","title":"styles_title__3Yn6p","logoWrapper":"styles_logoWrapper__1i-z_","logo":"styles_logo__325yb","logoImage":"styles_logoImage__19kWi"};